import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "projects/ert/src/environments/environment";
import {
  ObjectFile,
  UploadData,
} from "../../interfaces/shared/file-upload/upload-data";

@Injectable({
  providedIn: "root",
})
export class FileService {
  private baseUrl: string = environment.apiUrl + "/files";

  constructor(private http: HttpClient) {}

  public uploadFile(formData: FormData): Observable<string> {
    return this.http.post<string>(this.baseUrl + "/upload", formData);
  }

  public getAllFiles(
    entityType: string,
    objectId: number
  ): Observable<ObjectFile[]> {
    const safeObjectId = encodeURIComponent(objectId.toString());
    const safeEntityType = encodeURIComponent(entityType);

    return this.http.get<ObjectFile[]>(
      `${this.baseUrl}/all/${safeObjectId}/${safeEntityType}`
    );
  }

  public downloadFile(
    fileId: string,
    entityType: string,
    facilityName: string
  ): Observable<Blob> {
    const safeFileId = encodeURIComponent(fileId);
    const safeEntityType = encodeURIComponent(entityType);
    const safeFacilityName = encodeURIComponent(facilityName);

    return this.http.get(
      `${this.baseUrl}/download/${safeFileId}/${safeEntityType}/${safeFacilityName}`,
      {
        responseType: "blob",
      }
    );
  }

  deleteFile(
    fileId: string,
    entityType: string,
    facilityName: string
  ): Observable<boolean> {
    const safeFileId = encodeURIComponent(fileId);
    const safeEntityType = encodeURIComponent(entityType);
    const safeFacilityName = encodeURIComponent(facilityName);

    return this.http.delete<boolean>(
      `${this.baseUrl}/delete/${safeFileId}/${safeEntityType}/${safeFacilityName}`
    );
  }
}
